import { render } from "./ConfirmEmailPage.vue?vue&type=template&id=8cf3e1f6&scoped=true&ts=true"
import script from "./ConfirmEmailPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailPage.vue?vue&type=script&lang=ts"

import "./ConfirmEmailPage.vue?vue&type=style&index=0&id=8cf3e1f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf3e1f6"]])

export default __exports__